import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /nom-bonic-programa/clips-audio
let path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'clips-audio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);
    path = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'custom-radio', '' + mapping.id, 'clips-video'];

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
